var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClouds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 67,
    viewBox: "0 0 246 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_509_4287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.09 13.435C90.09 13.435 80.01 0.614986 70.53 0.614986C61.05 0.614986 59.74 11.405 57.01 12.745C54.28 14.085 42.85 6.67499 38.13 8.74499C33.41 10.815 32.06 18.195 32.06 18.195C32.06 18.195 23.29 13.475 19.24 15.495C15.19 17.515 11.15 23.585 11.15 23.585L0.360016 28.305H113.66C113.66 28.305 113.66 15.495 106.24 13.475C98.82 11.455 97.51 22.195 90.09 13.435Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.95 20.485C232.95 20.485 227.65 13.775 222.7 13.775C217.75 13.775 217.04 19.425 215.63 20.135C214.22 20.845 208.2 16.955 205.73 18.015C203.26 19.075 202.55 22.965 202.55 22.965C202.55 22.965 197.95 20.485 195.83 21.555C193.71 22.625 191.58 25.795 191.58 25.795L185.93 28.265H245.33C245.33 28.265 245.33 21.555 241.44 20.485C237.55 19.415 236.84 25.085 232.95 20.485Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.4 57.745C135.4 57.745 129.54 50.315 124.07 50.315C118.6 50.315 117.82 56.575 116.25 57.315C114.68 58.055 108.05 53.795 105.31 54.965C102.57 56.135 101.79 60.445 101.79 60.445C101.79 60.445 96.71 57.705 94.37 58.875C92.03 60.045 89.68 63.565 89.68 63.565L83.42 66.305H149.08C149.08 66.305 149.08 58.875 144.79 57.705C140.5 56.535 139.7 62.865 135.4 57.745Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_509_4287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 247.83,
    height: 66.77,
    fill: "white",
    transform: "translate(-2 0.11499)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClouds);
export default __webpack_public_path__ + "static/media/clouds.96471401a5fb68094bf4502810187440.svg";
export { ForwardRef as ReactComponent };